<template>
  <div id="app">
    <Header :showLinks="showLinks" />

    <slot />
    <Chat />

    <Footer />
  </div>
</template>

<script>
import "../../icons/";
import Header from "./components/Header";
import Footer from "./components/Footer";

export default {
  components: {
    Header,
    Footer
  },
  props: {
    showLinks: {
      type: Boolean,
      default: true
    }
  }
};
</script>
